// extracted by mini-css-extract-plugin
export default {"container":"error-fallback_container__RJhuh","header":"error-fallback_header__Hvnpf","info":"error-fallback_info__7kYY-"};